import React from 'react';
import ReactDOM from 'react-dom/client';
import HddnLabBooking from '../hddn-lab-booking.jsx';
import { initMetaPixel } from './meta-pixel.js';

initMetaPixel();

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    this.setState({ info });
    if (typeof console !== 'undefined') console.error('ErrorBoundary caught:', error, info);
  }
  render() {
    if (this.state.error) {
      const err = this.state.error || {};
      const name = err.name || 'Error';
      const message = err.message || String(err) || '(no message)';
      const stack = err.stack || '';
      const componentStack = (this.state.info && this.state.info.componentStack) || '';
      return (
        <div style={{ fontFamily: "'Space Mono', monospace", padding: 20, color: '#2c2016', background: '#faf8f3', minHeight: '100vh' }}>
          <h2 style={{ color: '#a84032', margin: '0 0 12px' }}>Something went wrong</h2>
          <p style={{ fontSize: 13, marginBottom: 12 }}>The page hit a runtime error. Send this to support:</p>
          <div style={{ background: '#fdf2f0', border: '1px solid #a84032', padding: 12, borderRadius: 4, marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#a84032', letterSpacing: 1, marginBottom: 4 }}>{name}</div>
            <div style={{ fontSize: 14, color: '#2c2016', wordBreak: 'break-word' }}>{message}</div>
          </div>
          <details>
            <summary style={{ fontSize: 11, color: '#7a6e60', cursor: 'pointer', marginBottom: 8 }}>Stack trace</summary>
            <pre style={{ fontSize: 10, background: '#f5f1e8', padding: 10, borderRadius: 4, overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word', border: '1px solid #d9d0c3' }}>
{stack}
{componentStack ? `\n\n--- component stack ---\n${componentStack}` : ''}
            </pre>
          </details>
          <button onClick={() => { window.location.href = '/'; }} style={{ marginTop: 16, padding: '10px 20px', background: '#3d2b1f', color: '#faf8f3', border: 'none', cursor: 'pointer', fontFamily: "'Space Mono', monospace", fontSize: 12, letterSpacing: 1 }}>
            ← Reload home
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <HddnLabBooking />
    </ErrorBoundary>
  </React.StrictMode>
);
